module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-510.6ae0e36.woff2";